/**
 * Cross-Origin "zuletzt aktiver Bereich"-Marker (Admin-Seite).
 *
 * Pendant zu `frontend/src/api/lastAreaCookie.js`. member.telephonio.com
 * (Admin-CRM) und telephonio.com (Kunden-Frontend) teilen sich die
 * Parent-Domain `telephonio.com`, haben aber getrennten localStorage. Der
 * zuletzt aktive Bereich wird daher in einem Cookie auf `.telephonio.com`
 * gehalten, das beide Origins lesen/schreiben koennen.
 *
 * Beim (Kalt-)Start der nativen App liest das Frontend dieses Cookie und
 * leitet — falls "admin" — direkt nach member.telephonio.com weiter. Rein
 * web-seitig, kein neuer Native-Build noetig.
 */
export const LAST_AREA_COOKIE = "telephonio_last_area";

function cookieDomainAttr() {
  try {
    const host = (window.location.hostname || "").toLowerCase();
    if (host === "telephonio.com" || host.endsWith(".telephonio.com")) {
      return "; domain=.telephonio.com";
    }
  } catch (_) {}
  return "";
}

function writeLastArea(area) {
  try {
    const secure = window.location.protocol === "https:" ? "; secure" : "";
    document.cookie =
      LAST_AREA_COOKIE +
      "=" +
      encodeURIComponent(area) +
      cookieDomainAttr() +
      "; path=/; max-age=31536000; samesite=Lax" +
      secure;
  } catch (_) {}
}

/** Markiert den Admin-Bereich (member.telephonio.com) als zuletzt aktiv. */
export function markAdminArea() {
  writeLastArea("admin");
}

/** Markiert das Kunden-Frontend (telephonio.com) als zuletzt aktiven Bereich. */
export function markFrontendArea() {
  writeLastArea("frontend");
}

/** Liefert `"frontend"` | `"admin"` | `""` (nicht gesetzt). */
export function readLastArea() {
  try {
    const m = document.cookie.match(
      /(?:^|;\s*)telephonio_last_area=([^;]+)/,
    );
    return m ? decodeURIComponent(m[1]) : "";
  } catch (_) {
    return "";
  }
}
